import React from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { handlePrintData } from "../utils/PrintData";
import { FaCheck, FaTimes } from "react-icons/fa";
import moment from "moment";

function OcafData({ item, edit }) {
  const calculateTotalNet = () => {
    return item?.items?.reduce(
      (accumulator, currentItem) => accumulator + currentItem.net,
      0
    );
  };

  return (
    <div
      className="ocaf-form"
      style={{ fontSize: "10px", fontFamily: "Arial, sans-serif" }}
    >
      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            table {
              page-break-inside: auto;
              width: 100%;
            }
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
          }
        `}
      </style>

      <h3 className="text-xl text-center font-bold mb-2">OCAF 2.0</h3>

      {/* First Row - Two Columns */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        {/* Left Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            To be completed &amp; ID verified by the reception/nurse:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Provider Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.payer_name || item?.patient?.insurance_plans?.[0]?.payer_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">
                Insurance Company Name:
              </span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.payer_name || item?.patient?.insurance_plans?.[0]?.payer_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">TPA Company Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.tpa_license_id || item?.patient?.insurance_plans?.[0]?.tpa_license_id}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Patient MRN:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.file_no}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Single () Married ():</span>
              <span>Plan Type : </span>
              <span className="border-b border-dotted px-2 border-black flex-1">
                {item?.patient?.selected_plan?.coverage_type || item?.patient?.insurance_plans?.[0]?.coverage_type}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Date Of Visit:</span>
              <span className="border-b border-dotted border-black flex-1">
                {moment(item?.visit_date).format("DD-MM-YYYY")}
              </span>
            </div>
            <div className="flex space-x-2">
              <span>New Visit()</span>
              <span>FollowUp()</span>
              <span>Refill()</span>
              <span>WalkIn()</span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center">
                <span className="font-semibold mr-1">Referrel:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item && item.is_referral ? "YES" : "NO"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold mr-1">Refer To:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.dischargeDisposition}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            Print &amp; fill in clear letters or Emboss Card:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Insured Name:</span>
              <span className="border-b border-dotted border-black flex-1 capitalize">
                {item?.patient?.full_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">ID Card Number:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.member_card_id || item?.patient?.insurance_plans?.[0]?.member_card_id}
              </span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Sex:</span>
                <span className="border-b border-dotted border-black flex-1 capitalize">
                  {item?.patient?.gender}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Date of Birth:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.dob}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Holder:</span>
                <span className="border-b border-dotted border-black flex-1">
                  YES
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Number:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.policy_number || item?.patient?.insurance_plans?.[0]?.policy_number}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Date Of Expiry:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.expiry_date || item?.patient?.insurance_plans?.[0]?.expiry_date}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Class:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.class_name || item?.patient?.insurance_plans?.[0]?.class_name}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.pre_auth_ref_no}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Response Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {!(item?.status === "approved")
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Status:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status === "approved"
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Optician Section */}
      <div className="border border-black p-1 rounded mb-2">
        <h3 className="text-sm font-bold mb-1">To be completed by Optician</h3>

        {/* Eye Tables */}
        <div className="flex flex-row gap-2 mb-2">
          {/* Right Eye Table */}
          <div className="flex-1">
            <table className="w-full border border-black border-collapse text-center text-xs">
              <thead>
                <tr>
                  <th
                    colSpan={5}
                    className="border border-black px-1 py-1 font-bold"
                  >
                    RIGHT EYE
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th className="border border-black px-1 py-1">Sphere</th>
                  <th className="border border-black px-1 py-1">Cylinder</th>
                  <th className="border border-black px-1 py-1">Axis</th>
                  <th className="border border-black px-1 py-1">Prism</th>
                  <th className="border border-black px-1 py-1">V/N</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border h-[1.5rem] border-black font-semibold px-1 py-1 text-gray-700">
                    Distance
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.distance?.sphere}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.distance?.cylinder}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.distance?.axis}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.distance?.prism}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.distance?.vn}
                  </td>
                </tr>
                <tr>
                  <td className="border h-[1.5rem] border-black font-semibold px-1 py-1 text-gray-700">
                    Near
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.near?.sphere}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.near?.cylinder}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.near?.axis}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.near?.prism}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.rightEye?.near?.vn}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex-1">
            <table className="w-full border border-black border-collapse text-center text-xs">
              <thead>
                <tr>
                  <th
                    colSpan={5}
                    className="border border-black px-1 py-1 font-bold"
                  >
                    LEFT EYE
                  </th>
                </tr>
                <tr>
                  <th className="border border-black px-1 py-1">Sphere</th>
                  <th className="border border-black px-1 py-1">Cylinder</th>
                  <th className="border border-black px-1 py-1">Axis</th>
                  <th className="border border-black px-1 py-1">Prism</th>
                  <th className="border border-black px-1 py-1">V/N</th>
                  <th>PD</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border h-[1.5rem] border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.sphere}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.cylinder}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.axis}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.prism}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.vn}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.distance?.pd}
                  </td>
                </tr>
                <tr>
                  <td className="border h-[1.5rem] border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.sphere}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.cylinder}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.axis}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.prism}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.vn}
                  </td>
                  <td className="border border-black px-1 py-1">
                    {item?.ophthalmology?.leftEye?.near?.pd}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-2">
          <div className="flex border border-black">
            <p className="font-bold px-4 py-1 border-black border-r">
              Bifocal Right
            </p>
            <p className="font-bold px-4 py-1 flex items-center gap-2">
              {item?.ophthalmology?.bifocalRight ? (
                <>
                  <FaCheck size={16} className="text-black" />
                </>
              ) : (
                "Add"
              )}
            </p>
          </div>
          <div className="flex border border-black">
            <p className="font-bold px-4 py-1 border-black border-r">Vertex</p>
            <p className="font-bold px-4 py-1 flex items-center gap-2">
              {item?.ophthalmology?.vertex ? (
                <>
                  <FaCheck size={16} className="text-black" />
                </>
              ) : (
                "Add"
              )}
            </p>
          </div>
          <div className="flex border border-black">
            <p className="font-bold px-4 py-1 border-black border-r">
              Bifocal Left
            </p>
            <p className="font-bold px-4 py-1 flex items-center gap-2">
              {item?.ophthalmology?.bifocalLeft ? (
                <>
                  <FaCheck size={16} className="text-black" />
                </>
              ) : (
                "Add"
              )}
            </p>
          </div>
        </div>

        {/* Lenses Type */}
        <div className="flex flex-wrap justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <span className="font-bold">Regular Lenses Type:</span>
            <div className="flex gap-5">
              <div className="checkbox-container flex items-center gap-4">
                <div class="inline-flex items-center">
                  <label class="flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      checked={
                        item?.ophthalmology?.regularLensesType == "glass"
                      }
                      class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                      id="check"
                    />
                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                </div>

                <span>Glass</span>
              </div>
              <div className="checkbox-container flex items-center gap-4">
                <div class="inline-flex items-center">
                  <label class="flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      checked={
                        item?.ophthalmology?.regularLensesType == "plastic"
                      }
                      class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                      id="check"
                    />
                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                </div>
                <span>Plastic</span>
              </div>
              <div className="checkbox-container flex items-center gap-4">
                <div class="inline-flex items-center">
                  <label class="flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      checked={item?.ophthalmology?.regularLensesType == "none"}
                      class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                      id="check"
                    />
                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                </div>
                <span>None</span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="font-bold">Contact Lenses Type:</span>
            <div className="flex gap-1">
              <div className="checkbox-container flex items-center gap-4">
                <div class="inline-flex items-center">
                  <label class="flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      checked={
                        item?.ophthalmology?.contactLensesType == "permanent"
                      }
                      class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                      id="check"
                    />
                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                </div>
                <span>Permanent</span>
              </div>
              <div className="checkbox-container flex items-center gap-4">
                <div class="inline-flex items-center">
                  <label class="flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      checked={
                        item?.ophthalmology?.contactLensesType == "disposal"
                      }
                      class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                      id="check"
                    />
                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                </div>

                <span>Disposal</span>
              </div>
            </div>
          </div>
        </div>

        {/* Lenses Specification */}
        <div className="mb-2">
          <h3 className="font-bold mb-1">Lenses Specification:</h3>
          <div className="grid grid-cols-3 md:grid-cols-5 gap-1 text-xs">
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.multiCoated
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Multi-coated</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.varilux}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Varilux</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.light}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Light</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.aspheric}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Aspheric</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.medium}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Medium</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.lenticular
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Lenticular</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.singleVision
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Single Vision</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.dark}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Dark</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.safetyThickness
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Safety Thickness</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification
                        ?.antiReflectingCoating
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Anti-reflecting coating</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.photosensitive
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Photosensitive</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.highIndex
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>High Index</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.colored}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Colored</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.lensesSpecification?.bifocal}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Bifocal</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={
                      item?.ophthalmology?.lensesSpecification?.antiScratch
                    }
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Anti-Scratch</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 mb-2">
          <span className="font-bold">Frames:</span>
          <div className="flex gap-2">
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={item?.ophthalmology?.frames}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>Yes</span>
            </div>
            <div className="checkbox-container flex items-center gap-4">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    checked={!item?.ophthalmology?.frames}
                    class="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                    id="check"
                  />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      stroke="currentColor"
                      stroke-width="1"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </label>
              </div>
              <span>No</span>
            </div>
          </div>
        </div>

        {/* Pairs and Cost */}
        <div className="flex flex-col md:flex-row justify-between gap-2 mb-1">
          <div className="flex items-center gap-2">
            <span className="font-bold">Please specify # of pairs:</span>
            <span className="border-b border-dotted border-black w-16"></span>
          </div>
          <div className="flex flex-row md:flex-row gap-2">
            <p className="font-bold">Estimated Cost :</p>
            <div className="flex items-center gap-2">
              <span className="font-bold">Leases: SR</span>
              <span className="border-b border-dotted border-black w-16"></span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-bold">Frame: SR</span>
              <span className="border-b border-dotted border-black w-16"></span>
            </div>
          </div>
        </div>
      </div>

      {/* Certifications */}
      <div className="border border-black p-1 rounded mb-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {/* Optician Certification */}
          <div className="border-r border-gray-300 pr-2">
            <p className="text-xs mb-1">
              I hereby certify that All information mentioned are correct and
              that the services shown on this form were medically indicated and
              necessary for of this case.
            </p>
            <div className="flex justify-between">
              <div className="flex flex-col">
                <span className="font-bold">Optician</span>
                <span className=" border-black">
                  {edit
                    ? item?.careTeamsArr
                      ?.map((care) => care.practitionerName)
                      .join(", ")
                    : item?.careTeamsArray
                      ?.map((care) => care.practitionerName)
                      .join(", ")}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Signature</span>
                <span className="  border-black"></span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Stamp</span>
                <input type="radio" className="mt-1" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Date</span>
                <span className=" border-black"></span>
              </div>
            </div>
          </div>

          {/* Patient Certification */}
          <div className="pl-2">
            <p className="text-xs mb-1">
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </p>
            <div className="mb-1">
              <div className="flex items-center">
                <span className="font-bold mr-1">
                  Name (and relationship (if guardian)):
                </span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Signature:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Date:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Insurance Company Section */}
      <div className="border border-black p-1 rounded">
        <div className="mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">
              For Insurance Company Use Only:
            </span>
            <div className="flex space-x-20">
              <span>Approved ( )</span>
              <span>Not Approved ( )</span>
              <span>Approval No:</span>
              <span>Approval validity:</span>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <span>
            Days Comments (include approved days/services if different from the
            requested):
          </span>
        </div>

        <hr className="border-t border-black my-1" />

        <div className="flex space-x-2">
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Approved/Disapproved By:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Signature:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Date:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>
      </div>

      <p className="text-xs font-bold mt-1">
        (*) This is applicable only in case of manual OCAF
      </p>
    </div>
  );
}

function OcafForm({
  showOcaf = true,
  setShowOcaf = () => { },
  item = null,
  edit = false,
}) {
  const handlePrint = async () => {
    const printContent = document.getElementById("print-content");
    if (!printContent) return;
    await handlePrintData(printContent.innerHTML);
  };

  return (
    <Dialog
      visible={showOcaf}
      onHide={() => setShowOcaf(false)}
      style={{ width: "80vw", maxWidth: "1200px" }}
      header="Optical Claim Authorization Form"
      modal
      breakpoints={{ "960px": "75vw", "640px": "90vw" }}
      draggable={false}
      resizable={false}
    >
      <div id="print-content">
        <OcafData item={item} edit={edit} />
      </div>
      <div className="sticky bottom-0 bg-white p-4 pt-3 border-t">
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => setShowOcaf(!showOcaf)}
          >
            Close
          </button>
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default OcafForm;
